"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollStatus;
(function (ScrollStatus) {
    ScrollStatus["AT_TOP"] = "AT_TOP";
    ScrollStatus["SCROLLED"] = "SCROLLED";
    ScrollStatus["AT_BOTTOM"] = "AT_BOTTOM";
})(ScrollStatus || (ScrollStatus = {}));
exports.default = ScrollStatus;
//# sourceMappingURL=ScrollStatus.js.map